import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SettingsComponent } from '../../../../shared/components/printer/settings/settings.component';

@Component({
  selector: 'app-user-defined-printer',
  templateUrl: './user-defined-printer.component.html',
  styleUrls: ['./user-defined-printer.component.css']
})
export class UserDefinedPrinterComponent implements OnInit, AfterViewInit {

  @ViewChild("thePrinterSetting") child: SettingsComponent;

  constructor(private route: ActivatedRoute) { }

  parameters = null;

  ngOnInit(): void {
    this.route.queryParams
      .subscribe(params => {
        this.parameters = {
          ClientIPAddress: params.ClientIPAddress,
          OperatorPanelToken: params.OperatorPanelToken,
          Client: params.Client
        };
      }
    );
  }

  ngAfterViewInit() {
    
    this.child.setPrinterDataSource();
  }

}
